import { PropsWithChildren } from 'react'
import { PortableTextProps } from '@portabletext/react'
import { FieldHints } from './field-hints'
import { fieldContainerClasses, labelClasses } from './classes'

export interface FieldWrapperProps {
  id?: string
  characterLimit?: number
  hideLimitHint?: boolean
  errorText?: string | PortableTextProps['value']
  hasError?: boolean
  helperText?: PortableTextProps['value']
  htmlFor?: string
  label?: string
  length?: number
  hide?: boolean
  required?: boolean
}

/** Base component including container, label and hints for text/select/area fields */
export const FieldWrapper = ({
  id,
  characterLimit,
  hideLimitHint,
  children,
  errorText,
  hasError = false,
  helperText,
  htmlFor,
  label,
  length,
  hide,
  required,
}: PropsWithChildren<FieldWrapperProps>) => {
  if (hide) {
    // We need this Fragment for typing purposes
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  return (
    <div className={fieldContainerClasses}>
      <label htmlFor={htmlFor} className={labelClasses}>
        {label}
        {required && <span className="text-feedback-negative-300 ml-1">*</span>}
      </label>
      {children}
      <FieldHints
        id={id ? `${id}-hints` : undefined}
        helperText={helperText}
        hideLimitHint={hideLimitHint}
        errorText={errorText}
        characterLimit={characterLimit}
        hasError={hasError}
        length={length}
      />
    </div>
  )
}
